import moment from "moment-timezone";
import "moment/locale/fr";

// Mapping des codes d'erreur structures de l'API vers messages user-friendly
const FRAME_ERROR_MESSAGES = {
    FRAME_OFFLINE:   "Cadre injoignable — verifiez qu'il est sous tension et connecte",
    FRAME_TIMEOUT:   "Le cadre met trop de temps a repondre",
    FRAME_REFUSED:   "Le cadre a refuse la connexion — verifiez qu'il est allume et sur le reseau",
    FRAME_KEY:       "Cle d'authentification du cadre invalide",
    FRAME_HW:        "L'ecran n'a pas pu etre rafraichi (probleme materiel)",
    FRAME_UNKNOWN:   "Erreur inconnue avec le cadre",
    LIBRARY_EMPTY:   "La bibliotheque selectionnee est vide",
    LIBRARY_MISSING: "Aucune bibliotheque assignee",
};

export async function GetAllFrames(token) {
    const response = await fetch("/api/frames", {
        method: 'GET',
        headers: new Headers({
            'Authorization': 'Bearer ' + token,
        }),
        redirect: 'follow'
    });
    let responseJson = await response.json();
    if (responseJson.message) throw responseJson;
    
    return responseJson.map( (frame) => {
        return {
            ...frame,
            idx: frame.idx,
            id: frame._id.$oid,
            title: frame.name,
            subTitle: frame.inch + '" - ' + frame.resolution_width + "x"+ frame.resolution_height + " - " + frame.ip,
            date: moment.utc(frame.created_at).tz("Europe/Paris").fromNow(),
            width: frame.resolution_width,
            height: frame.resolution_height
        }
    })
}

export async function PostFrame(token, name, ip, key, inch, resolution_width, resolution_height, orientation, type) {
    let formdata = new FormData();
    formdata.append("name", name);
    formdata.append("ip", ip);
    formdata.append("key", key);
    formdata.append("inch", inch);
    formdata.append("rWidth", resolution_width);
    formdata.append("rHeight", resolution_height);
    formdata.append("type", type);
    formdata.append("orientation", orientation);

    const response = await fetch("/api/frame", {
        method: 'POST',
        headers: new Headers({
            'Authorization':  'Bearer ' + token,
        }),
        body: formdata
    });

    let responseJson = await response.json();
    if (responseJson.message) {
        throw responseJson;
    }

    return responseJson;
}


export async function GetFrame(token, idFrame) {
    const response = await fetch("/api/frame/"+idFrame, {
        method: 'GET',
        headers: new Headers({
            'Authorization': 'Bearer ' + token,
        }),
        redirect: 'follow'
    });

    let responseJson = await response.json();
    if (responseJson.message) throw responseJson;

    return responseJson;
}


export async function UpdateFrame(token, idFrame, data) {
    let formdata = new FormData();
    Object.entries(data).forEach(([key, val]) => {
        if (val !== undefined && val !== null) formdata.append(key, val);
    });

    const response = await fetch("/api/frame/"+idFrame, {
        method: 'PUT',
        headers: new Headers({
            'Authorization': 'Bearer ' + token,
        }),
        body: formdata
    });

    let responseJson = await response.json();
    if (responseJson.message) throw responseJson;

    return responseJson;
}


export async function DeleteFrame(token,  idFrame) {
    const response = await fetch("/api/frame/"+idFrame, {
        method: 'DELETE',
        headers: new Headers({
            'Authorization':  'Bearer ' + token,
        })
    });

    let responseJson = await response.json();
    if (responseJson.message) throw responseJson;

    return responseJson;
}


export async function ChangeFrameLibraryDisplay(token, idFrame, idLibrary) {
    let formdata = new FormData();
    formdata.append("idLibrary", idLibrary);
    
    const response = await fetch("/api/frame/"+idFrame, {
        method: 'PUT',
        headers: new Headers({
            'Authorization':  'Bearer ' + token,
        }),
        body: formdata
    });

    let responseJson = await response.json();
    if (responseJson.message) throw responseJson;

    return responseJson;
}

export async function EventToFrame(token, idFrame, idLibrary) {
    let formdata = new FormData();
    formdata.append("frame", idFrame);
    formdata.append("library", idLibrary);

    const response = await fetch("/api/eventtoframe", {
        method: 'POST',
        headers: new Headers({
            'Authorization':  'Bearer ' + token,
        }),
        body: formdata
    });

    let responseJson = await response.json();
    // Format structure { error: { code, message } }
    if (responseJson?.error?.code) {
        throw { message: FRAME_ERROR_MESSAGES[responseJson.error.code] || responseJson.error.message, code: responseJson.error.code };
    }
    if (responseJson.message) throw responseJson;

    // Enriched payload: { success, last_picture_id, last_picture_name, status }
    return responseJson;
}


export async function EventToFrameUser(token, idFrame, idPicture) {
    let formdata = new FormData();
    formdata.append("frame", idFrame);
    formdata.append("picture", idPicture);

    const response = await fetch("/api/eventtoframeuser", {
        method: 'POST',
        headers: new Headers({
            'Authorization': 'Bearer ' + token,
        }),
        body: formdata
    });

    let responseJson = await response.json();
    if (responseJson.message) throw responseJson;

    return responseJson;
}


export const ListOrientation = [{
    title: "Portrait",
    value: "portrait"
}, {
    title: "Paysage",
    value: "paysage"
}];

export function ConvertKeyToStringOrientation (key) {
    switch (key) {
        case "paysage":
            return "Paysage";
        case "portrait":
            return "Portrait"
        default:
            return "Error"
    }
}

export const ListType = [{
    title: "E-Paper - Raspberry",
    value: "e_paper_raspbery"
}, {
    title: "E-Paper - Arduino",
    value: "e_paper_arduino"
}];

export function ConvertKeyToStringType (key) {
    switch (key) {
        case "e_paper_raspbery":
            return "E-Paper - Raspberry";
        case "e_paper_arduino":
            return "E-Paper - Arduino"
        default:
            return "Error"
    }
}
